'use client';

import { useEffect } from 'react';
import useMolocoLogger from '@hooks/useMolocoLogger';
import { usePathname } from 'next/navigation';

export function MolocoLog<T>({
  type = 'PAGE_VIEW',
}: {
  type: 'HOME' | 'PAGE_VIEW';
}) {
  const pathname = usePathname();
  const { sendMolocoPageView } = useMolocoLogger();
  useEffect(() => {
    const init = async () => {
      await sendMolocoPageView({
        type,
        pageId: pathname,
      });
    };
    init();
  }, []);

  return null;
}
